import { render, staticRenderFns } from "./SysIdentityManageModal.vue?vue&type=template&id=6244b146&"
import script from "./SysIdentityManageModal.vue?vue&type=script&lang=js&"
export * from "./SysIdentityManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports